import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IMissionResource } from "../types";

export interface IMissionDeleteMutationParameters {
    mission: RelationalValue<IMissionResource>;
}

export type IMissionDeleteMutationResult = void;

export const missionDeleteMutation: IApiMutationFunction<IMissionDeleteMutationParameters> = ({ mission }) => {
    return {
        method: "DELETE",
        url: `/missions/${mapRelationalValue(mission)}`,
    };
};

export const useMissionDeleteMutation = createApiMutationHook<
    IMissionDeleteMutationParameters,
    IMissionDeleteMutationResult
>(missionDeleteMutation);
